import { useSearchParams } from 'react-router-dom';
import MainInfoTracLayout from '../../../components/Layout/Main';
import useENotification from '../../../../hooks/eNotification';

const path = '../oldPages/e-notification/filled-template/index.html';

function ENotificationFilledTemplate() {
  const { iframeRef } = useENotification();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const iframeSrc = id ? `${path}?id=${encodeURIComponent(id)}` : path;

  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <iframe ref={iframeRef} title="e-notification-filled-template" src={iframeSrc} width="100%" height="1300px" />
    </MainInfoTracLayout>
  );
}

export default ENotificationFilledTemplate;
